/* This file is generated by scripts/generate-build-meta.js. */
export const GENERATED_BUILD_META = Object.freeze({
  "version": "1.7.1",
  "buildId": "20260831-1735-482bf8c",
  "builtAt": "2026-08-31T12:05:59.544Z"
});
